interface RedirectParams {
  frontPage: string;
  redirectUrl: string;
}

/**
 * Build redirect params.
 * from session storage to determine the preferred front page of the app, defaulting to value in env.
 *
 * Returns preferred front page as well as current url.
 */
export const buildRedirectParams = (): RedirectParams => {
  const pathname = import.meta.env.VITE_USER_FRONTPAGE;

  const redirectUrl = `${window.location.protocol}//${window.location.host}${pathname}`;
  return {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frontPage: pathname!,
    redirectUrl,
  };
};
